import PropTypes from 'prop-types'
import styled from 'styled-components'

import checkboxSvg from '@h2/assets/svg/icons/checkbox.svg'

import { BLACK } from '../../colors'

const margin = {
  small: '0 0 14px 0',
  medium: '0 0 14px 0'
}
const padding = {
  small: '0 0 0 25px',
  medium: '0 0 0 35px'
}
const backgroundSizes = {
  small: '16px 14px',
  medium: '23px 20px'
}
const minHeights = {
  small: 'auto',
  medium: 'auto',
  variant: {
    'smaller-text': {
      small: null,
      // Need to be at least as tall as the checkbox icon used.
      medium: '22px'
    }
  }
}
const getMinHeight = ({ size, variant }) => {
  return minHeights.variant[variant]?.[size] ?? minHeights[size]
}
const StyledItem = styled.li`
  display: flex;
  align-items: center;
  min-height: ${getMinHeight};
  color: ${({ color }) => color ?? 'inherit'};
  margin: ${({ size }) => margin[size]};
  padding: ${({ size }) => padding[size]};
  list-style: none;
  background-image: url('${checkboxSvg}');
  background-repeat: no-repeat;
  background-position: left 2px;
  background-size: ${({ size }) => backgroundSizes[size]};

  &:last-child {
    margin-bottom: 0;
  }
`
const Item = ({ children, variant, size = 'medium', color = BLACK }) => {
  return (
    <StyledItem color={color} size={size} variant={variant}>
      <span>{children}</span>
    </StyledItem>
  )
}

Item.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['smaller-text', 'leading-down']),
  color: PropTypes.string
}

export { Item }
